<template>
  <v-toolbar dark dense elevation-3 card v-if="content.clippings">
    <v-menu>
      <v-btn slot="activator" flat dark >
        {{ clipping.name }}
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
            @click="$emit('input', index)"
            v-for="(clipping, index) in content.clippings"
            :key="clipping.id">
          <v-list-tile-content>
            <v-list-tile-title :class="{ 'accent--text': content.selection === index }">
              {{ clipping.name }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-tooltip top>
      <v-btn icon @click="$emit('crop')" slot="activator">
        <v-icon>crop</v-icon>
      </v-btn>
      <span v-html="$t('message.clipping.tool.crop')"></span>
    </v-tooltip>

  </v-toolbar>
</template>

<script>
export default {
  name: 'nx-clipping-tool-toolbar',
  props: {
    content: Object,
    clipping: Object,
    value: Number,
  },
};
</script>
